import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


    import { ref } from 'vue';
    import OnboardingGroupeComponent from "../onboarding-groupe/components/OnboardingGroupeComponent.vue";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CollectivitesManagementProspectsImportModal',
  setup(__props, { expose: __expose }) {

    // @ts-expect-error raison: lib externe mal typée
    const isOpened = ref(false);
    const collectivite = ref(null as any);
    let promise: Promise<boolean>;
    let resolvePromise: any;
    let rejectPromise: any;

    async function open(_collectivite: any) {
        collectivite.value = _collectivite;
        promise = new Promise((resolve, reject) => {
            resolvePromise = resolve;
            rejectPromise = reject;
        });
        isOpened.value = true;
        return await promise;
    }

    function onClose() {
        resolvePromise(false);
    }

    function onProspectsImported(datas: any) {
        resolvePromise(datas);
        isOpened.value = false;
    }

    __expose({ open, close });

return (_ctx: any,_cache: any) => {
  const _component_custom_modal = _resolveComponent("custom-modal")!

  return (_openBlock(), _createBlock(_component_custom_modal, {
    show: isOpened.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((isOpened).value = $event)),
    onClosed: onClose,
    classesNames: 'modal-fullscreen'
  }, {
    header: _withCtx(() => [...(_cache[1] || (_cache[1] = [
      _createTextVNode(" ", -1)
    ]))]),
    footer: _withCtx(() => [...(_cache[2] || (_cache[2] = [
      _createTextVNode(" ", -1)
    ]))]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(OnboardingGroupeComponent, {
          "is-widget-mode": false,
          collectivite: collectivite.value,
          onCompleted: onProspectsImported
        }, null, 8, ["collectivite"])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})